import { GridColDef } from '@material-ui/data-grid';

export const ColumnCodigo: GridColDef = {
  field: 'codigo',
  headerName: 'Código',
  width: 124,
};

export const ColumnNome: GridColDef = {
  field: 'nome',
  headerName: 'Nome',
  width: 500,
};

export const ColumnNomeFantasia: GridColDef = {
  field: 'nome_fantasia',
  headerName: 'Nome fantasia',
  width: 500,
};

export const ColumnTipoPessoa: GridColDef = {
  field: 'tipo_pessoa',
  headerName: 'Tipo pessoa',
  width: 160,
};

export const ColumnVinculoPessoa: GridColDef = {
  field: 'vinculo_pessoa',
  headerName: 'Vínculo pessoa',
  width: 180,
};

export const ColumnAccessKey: GridColDef = {
  field: 'access_key',
  headerName: '#',
  width: 400,
  hide: true,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};

export const ColumnID: GridColDef = {
  field: 'id',
  headerName: '#',
  width: 400,
  hide: true,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};
